import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    session_id: number;
    student_id: number;
}

interface IOutput {
	exam_status: number;
	exam_submit_id: number;
	setup: {[key: string]: string | number};
	time_setting: {
		end_time_stamp: number;
		end_time_stamp_from_submission_time: number;
		now_time_stamp: number;
		start_time_stamp: number;
	};
}

export const enterExam = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.ENTER_EXAM, data);
};
